/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throwing an error
 */
import 'zone.js/plugins/zone-error'; // Included with Angular CLI.

// TODO: Remove or find solution for prod.

import { InjectionToken } from '@angular/core';

// 'b1e4fad60945759aeebb1d1927d929873582fd39' is a build-time placeholder — CI (.stamp-sentry-release) and the
// Dockerfile sed it to $CI_COMMIT_SHA before `nx build` so the bundle carries the real Sentry release.
// Do not rename this const or reformat the literal; the sed target must stay exactly this string.
export const currentCommitHash: string = 'b1e4fad60945759aeebb1d1927d929873582fd39';

export const CURRENT_COMMIT_HASH = new InjectionToken<string>('Commit SHA');
